module.exports = __webpack_public_path__ + "img/nine.05b650b5.png";